const apiBase = "https://login-api-node-33dvsn7xmq-ew.a.run.app";

export { apiBase };
